import { Component, OnInit } from '@angular/core';
import {AuthService} from '../services/auth.service';

declare var $:any;

@Component({
  selector: 'app-topbar',
  templateUrl: './topbar.component.html',
  styleUrls: ['./topbar.component.css']
})
export class TopbarComponent implements OnInit {
  old_pwd;
  new_pwd;
  re_new_pwd;
  show_err;
  err_msg;
  show_success;
  success_msg;

  login_user;

  constructor(public authService : AuthService) {
    this.show_err = false;
    this.show_success = false;
  }

  ngOnInit() {
    this.old_pwd = "";
    this.new_pwd = "";
    this.show_err = false;
    this.show_success = false;
    this.err_msg = "";
    this.success_msg =  "";

    console.log("=======user data=========")
    //JSON.stringify(user));
    //console.log(localStorage.getItem('user'));

    try {
      this.login_user = JSON.parse(localStorage.getItem('user'));      
    } catch (error) {
      console.log(error);      
    }

  }
  changePwd(){
    let old_pwd = this.old_pwd;
    let new_pwd = this.new_pwd;
    let re_new_pwd = this.re_new_pwd;

    let __validate = true;
    let err_msg = "";

    if(!new_pwd || (new_pwd && (new_pwd == undefined || new_pwd ==""))){
      __validate = false;
      err_msg = "Please enter new password";
    }

    if(!re_new_pwd || (re_new_pwd && (re_new_pwd == undefined || re_new_pwd ==""))){
      __validate = false;
      err_msg = "Please enter re-password";
    }

    if(new_pwd !=re_new_pwd){
      __validate = false;      
      err_msg = "Password mismatch";
    }

    if(!__validate){
      this.show_err = true;
      this.err_msg = err_msg;
      return;
    }else{      
      this.show_err = false;
      this.err_msg = "";
    }

    this.show_success = false;
  

/*     console.log(`${__validate}===========old_pwd=======${old_pwd}`)
    console.log(`${this.show_err}===========new_pwd=======${new_pwd}`)
    console.log(`${this.err_msg}===========re_new_pwd=======${re_new_pwd}`) */
    
    this.authService.changePwd({old_password:old_pwd,password:new_pwd}).subscribe((res:any) =>{
      if(res.error){
        this.err_msg = res.message;
        this.show_err = true;
        return;
      }
  
      this.success_msg =  res.message;
      this.show_success = true;
      
      this.old_pwd = "";
      this.new_pwd = "";
      this.re_new_pwd = "";
      setTimeout(function(){
        $("#changePwdModal").modal("hide");
      },2000)
      
    })
    
  }


}



// WEBPACK FOOTER //
// /home/lynkit/Downloads/staging-boltseal/boltseal/newsletter-client/src/app/topbar/topbar.component.ts